exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#ace-editor {\n  height: calc(100vh - 46px) !important;\n}\n.SplitPane {\n  height: calc(100% - 46px) !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/less-loader!./src/plugins/editor/components/editor.less
// module id = 1244
// module chunks = 0